import { Backdrop, CircularProgress } from '@mui/material';
import * as React from 'react';

export const LoaderBackdrop = () => {
	return (
		<Backdrop open>
			<CircularProgress size={48} color={'primary'} />
		</Backdrop>
	);
};
